import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import MerchantRegistrationLayout from '../layout/MerchantRegistrationLayout';
import MerchantRegistrationGuard from '../components/utilities/MerchantRegistrationGuard';
import AuthOnlyRoute from '../components/utilities/authOnlyRoute';
import MerchantPaymentReturnRoute from '../components/utilities/MerchantPaymentReturnRoute';

// const MerchantOnboardingFlow = lazy(() => import('../container/pages/MerchantOnboardingFlow'));
const AdministrativeBillingDetailsFlow = lazy(() => import('../container/pages/AdministrativeBillingDetailsFlow'));
const ContractSignedFlow = lazy(() => import('../container/pages/ContractSignedFlow'));
const MerchantPaymentPage = lazy(() => import('../container/pages/MerchantPaymentPage'));
const MerchantRegistration = lazy(() => import('../container/pages/merchantRegistration'));

const MerchantRegistrationRoutes = React.memo(() => {
  return (
    <Routes>
      <Route
        path="/:package_slug/:source_slug"
        element={
          <MerchantRegistrationGuard>
            <MerchantRegistration />
          </MerchantRegistrationGuard>
        }
      />
      <Route
        path="administrative_billing_details_submitted"
        element={<AuthOnlyRoute Component={AdministrativeBillingDetailsFlow} />}
      />
      <Route path="contract_signed" element={<AuthOnlyRoute Component={ContractSignedFlow} />} />
      <Route path="payment" element={<AuthOnlyRoute Component={MerchantPaymentPage} />} />
      <Route path="merchant/payment/success" element={<MerchantPaymentReturnRoute />} />
    </Routes>
  );
});

export default MerchantRegistrationLayout(MerchantRegistrationRoutes);
